export const textStyles = {
    'xs-regular': {
        fontSize: 12,
        fontWeight: 400,
        lineHeight: '16px',
    },
    'xs-semibold': {
        fontSize: 12,
        fontWeight: 600,
        lineHeight: '16px',
    },
    'sm-regular': {
        fontSize: 14,
        fontWeight: 400,
        lineHeight: '20px',
    },
    'sm-medium': {
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '20px',
    },
    'base-regular': {
        fontSize: 16,
        fontWeight: 400,
        lineHeight: '24px',
    },
    'base-medium': {
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '24px',
    },
    'base-semibold': {
        fontSize: 16,
        fontWeight: 600,
        lineHeight: '24px',
    },
    'lg-regular': {
        fontSize: 18,
        fontWeight: 400,
        lineHeight: '28px',
    },
    'lg-medium': {
        fontSize: 18,
        fontWeight: 500,
        lineHeight: '28px',
    },
    'lg-semibold': {
        fontSize: 18,
        fontWeight: 600,
        lineHeight: '28px',
    },
    'xl-medium': {
        fontSize: 20,
        fontWeight: 500,
        lineHeight: '28px',
    },
    '2xl-regular': {
        fontSize: 24,
        fontWeight: 400,
        lineHeight: '32px',
    },
    '2xl-semibold': {
        fontSize: 24,
        fontWeight: 600,
        lineHeight: '32px',
    },
    '3xl-regular': {
        fontSize: 30,
        fontWeight: 400,
        lineHeight: '36px',
    },
    '3xl-medium': {
        fontSize: 30,
        fontWeight: 500,
        lineHeight: '36px',
    },
    '5xl-regular': {
        fontSize: 48,
        fontWeight: 400,
        lineHeight: '48px',
    },
};
